import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Router, Route, IndexRoute} from 'react-router';
import {connect} from 'react-redux';
import PageLayout from './PageLayout';
import {ProjectScopeLayoutComponents} from './ProjectScope';
import {NewScopeLayoutComponents} from './NewScope/newScope';
import {FeatureCreatorLayoutNewComponents} from './FeatureCreator';
import {StoneSetupLayoutComponents} from './StoneSetup';
import {StoneAssignPricingLayoutComponents} from './StoneSetup/AssignPricing';
import {FabricatorProfileLayoutComponents} from './FabricatorProfile';
import {LoginLayoutComponents} from './Login';
import {CustomersLayoutComponents} from './Customers/Customers';
import {EmployeesLayoutComponents} from './Employees/Employees';
import {FabricatorsLayoutComponents} from './Fabricators/Fabricators';
import {StoresLayoutComponents} from './Stores/Stores';
import {JobBoardLayoutComponents} from './JobBoard/JobBoard';
import {CentralHubLayoutComponents} from './PageLayout/CentralHub';
import {AddNewEntityLayoutComponents} from './AddNewEntity/AddNewEntity';
import {login, loadStoredTransientUpdates, setRedirectTo, getRedirectTo} from '../actions';
import * as actionTypes from '../constants/actionTypes';
import {AccessRights} from './../schemas/accessRightsModel';
import {SitesLayoutComponents} from './Sites/Sites';
import {VisualizerManagementLayoutComponents} from './VisualizerManagement/VisualizerManagement';
import {EmailTemplatesLayoutComponents} from './EmailTemplates/EmailTemplates';
import {EditTemplatesLayoutComponents} from './EditTemplates/EditTemplates';
import {FiltersLayoutComponents} from './Filters/Filters';
import {SkuFiltersLayoutComponents} from './Filters/SkuFilters/SkuFilters';
import {SkuFilterItemsLayoutComponents} from './Filters/SkuFilters/SkuFilterItems';
import {SkuFiltersAssignToProductComponents} from './Filters/SkuFilters/SkuFiltersAssignToProduct-v2';
import {FilterItemsLayoutComponents} from './Filters/FilterItems';
import {FeatureInclusionComponents} from './FeatureInclusion';
import {FeatureSelectionComponents} from './FeatureInclusion/FeatureSelection';
import {TaxControlLayoutComponents} from "./Taxes/Taxes";
import {InstallationLayoutComponents} from './Installations';
import {InstallationGroupItemsLayoutComponents} from './Installations/InstallationGroupItems';
import {ESignatureComponents} from "./eSignature/eSignatureComponents";
import {ProjectScopeNewLayoutComponents} from './ProjectScope/ProjectScopeNew';
import {DiscountsLayoutComponents} from './Discounts/discounts';
import Purchase from "./Purchase/purchase";
import {trySetAsCustomer} from "../reducers/asCustomer";
import {AccountPageLayoutComponents} from "./Account/AccountPage";
import AgentPageComponents from "./Agent/AgentPage";
import WizardSetupComponents from "./WizardSetup/WizardSetup";
import FeaturesSetupComponents from "./FeaturesSetup/FeaturesSetup";
import {generateAuthState} from './../reducers/auth';
import Pricing from "./Pricing/Pricing";

function mapStateToProps(state) {
  return {
    auth: state.auth,
    AR: AccessRights.get(state)
  };
}

function mapDispatchToProps(dispatch, props) {
  return {
    dispatch,
    login: () => dispatch(login)
  }
}

class app extends PureComponent {
  componentDidUpdate(prevProps) {
    const {authenticated} = this.props.auth;
    if (authenticated !== prevProps.auth.authenticated && authenticated) {
      const {redirectAfterLogin} = getRedirectTo();
      if (redirectAfterLogin) {
        this.props.history.push(redirectAfterLogin);
      } else {
        this.props.history.push('/');
      }
    } else {
      // logging out
      // here we are redirecting users to login and then redirect them again to mainpage / in auth.js,
      // so I removed it for asCustomer cases to prevent jumping from page to page
      if (!document.kvConfig.asCustomer) {
        this.props.history.replace('login');
      }
    }
  }

  componentDidMount() {
    //window.setInterval(this.props.login, 1000 * 60 * 10); //ping server every 10 minutes to keep session valid
    this.props.AR.setCurrentRoles(this.props.auth.roles);
    trySetAsCustomer();
  }

  scrollToTop = () => {
    const container = document.getElementsByTagName('section')[0];
    if (container) {
      container.scrollTop = 0;
    }
  };

  requireAuth = (nextState, replace) => {
    this.scrollToTop();
    const {authenticated} = this.props.auth;
    if (!authenticated) {
      replace(`/login`);
      setRedirectTo(nextState.location.pathname);
    } else {
      // Set the temporary saved Authentication object ito AccessRights
      // it will be re-validated later in the AJAX callback
      const {AR} = this.props;
      AR.setCurrentRoles(this.props.auth.roles);
      // if (AR.isClient() && nextState.location.pathname !== '/jobboard') {
      //   replace('/jobboard');
      //   setRedirectTo(nextState.location.pathname);
      //   return;
      // }

      // re-validate with server the Authentication information
      const result = this.props.login();
      result.payload
        .then(data => {
          // once we get back the new auth state from server, we need to check
          // with what we had locally saved, if any difference just ask user
          // to re-login
          if (!AccessRights.validateNewAuth(this.props.auth, data)) {
            // logout, this will reset all needed variables and redirect to login
            this.props.dispatch(actionTypes.LOGOUT);
          } else {
            // $(document).trigger('hub_reload'); // not needed.
          }
        })
        .catch((e) => {
          this.props.history.push('/login');
          setRedirectTo(nextState.location.pathname);
        });
    }
  };

  render() {
    const {history} = this.props;
    return (
      <Router history={history} key={Math.random()}>
        <Route path="/" component={PageLayout}>
          <IndexRoute components={CentralHubLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="scope" components={ProjectScopeNewLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="newscope" components={NewScopeLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="installations" components={InstallationLayoutComponents} onEnter={this.requireAuth} />
          <Route path="installations/items" components={InstallationGroupItemsLayoutComponents} onEnter={this.requireAuth} />
          <Route path="features" components={FeatureCreatorLayoutNewComponents} onEnter={this.requireAuth}/>
          <Route path="stones" components={StoneSetupLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="stones/pricing" components={StoneAssignPricingLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="profile" components={FabricatorProfileLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="customers" components={CustomersLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="employees" components={EmployeesLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="fabricators" components={FabricatorsLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="newaccount(?entityId=:entityId&clientType=:clientType&clientSubType=:clientSubType)"
                 components={AddNewEntityLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="account(?entityId=:entityId&clientType=:clientType&clientSubType=:clientSubType)"
                 components={AccountPageLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="stores" components={StoresLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="sites" components={SitesLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="visualizer-management" components={VisualizerManagementLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="email-templates" components={EmailTemplatesLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="edit-templates" components={EditTemplatesLayoutComponents} onEnter={this.requireAuth}/>
          {/*<Route path="jobboard/payment/:paymentJobId(/:paymentStep)" components={JobBoardLayoutComponents} onEnter={this.requireAuth}/>*/}
          <Route path="jobboard(/:editJobId)(/:signedRequest)" components={JobBoardLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="login(/:reset-password)" components={LoginLayoutComponents} onEnter={this.scrollToTop}/>
          <Route path="taxes" components={TaxControlLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="filters" components={FiltersLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="filterGroupItems(?filterGroupID=:filterGroupID)" components={FilterItemsLayoutComponents}
                 onEnter={this.requireAuth}/>
          <Route path="filtersAssignToFeatures"
                 components={require('./../components/Filters/Features/Features').FeaturesLayoutComponents}
                 onEnter={this.requireAuth}/>
          <Route path="filtersAssignToStones"
                 components={require('./../components/Filters/Stones/Stones').StonesLayoutComponents}
                 onEnter={this.requireAuth}/>
          <Route path="sku-filters" components={SkuFiltersLayoutComponents} onEnter={this.requireAuth}/>
          <Route path="sku-filterGroupItems(?filterGroupID=:filterGroupID)" components={SkuFilterItemsLayoutComponents}
                 onEnter={this.requireAuth}/>
          <Route path="assign-sku-filterGroupItems(?filterGroupID=:filterGroupID)" components={SkuFiltersAssignToProductComponents}
                 onEnter={this.requireAuth}/>
          <Route path="featureInclusion" components={FeatureInclusionComponents} onEnter={this.requireAuth} />
          <Route path="featureSelection" components={FeatureSelectionComponents} onEnter={this.requireAuth} />
          <Route path="esig" components={ESignatureComponents} onEnter={this.requireAuth} />
          <Route path="purchase" components={Purchase} />
          <Route path="pricing(/:paramsGroupName)(/:paramsCatalogName)" components={Pricing} />
          <Route path="discounts" components={DiscountsLayoutComponents} onEnter={this.requireAuth} />
          <Route path="agent" components={AgentPageComponents} onEnter={this.requireAuth}/>
          <Route path="wizard(/:wizardId)" components={WizardSetupComponents} onEnter={this.requireAuth}/>
          <Route path="features-setup" components={FeaturesSetupComponents} onEnter={this.requireAuth}/>
          <Route path="agent" components={AgentPageComponents} onEnter={this.requireAuth}/>
          <Route path="*" components={CentralHubLayoutComponents} onEnter={this.requireAuth}/>
        </Route>
      </Router>
    );
  }
}

app.propTypes = {
  login: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  auth: PropTypes.object
};

const App = connect(mapStateToProps, mapDispatchToProps)(app);

export default App;
